'use client';

import { renderAppIcon } from '@/components/icons/app-icon-registry';
import { Spinner } from '@/components/ui/feedback/status/spinner';
import type { WorkspaceReferenceMedia } from '../contracts/runtime-state';

export function WorkspaceReferenceMediaCard({
  item,
  uploadingLabel,
  removeLabel,
  onRemove,
  bannerLabel,
}: {
  item: WorkspaceReferenceMedia;
  uploadingLabel: string;
  removeLabel: string;
  onRemove?: (id: string) => void;
  bannerLabel?: string;
}) {
  const uploadingStatusLabel =
    typeof item.uploadProgress === 'number'
      ? `${uploadingLabel} · ${Math.min(
          100,
          Math.max(0, Math.round(item.uploadProgress))
        )}%`
      : uploadingLabel;

  return (
    <div
      className="cms-block-workspace-workspace-1-workspace-form-controls__uploadThumbCard"
      data-upload-status={item.uploadStatus}
      data-media-kind={item.kind}
      title={item.displayName}
    >
      {item.uploadStatus === 'uploading' ? (
        <output
          className="cms-block-workspace-workspace-1-workspace-form-controls__uploadSingleLoading cms-block-workspace-workspace-1-workspace-form-controls__uploadSingleLoadingCompact"
          aria-label={uploadingStatusLabel}
          aria-live="polite"
        >
          <Spinner
            className="cms-block-workspace-workspace-1-workspace-form-controls__uploadSingleLoadingSpinner cms-block-workspace-workspace-1-workspace-form-controls__uploadSingleLoadingSpinnerCompact"
            aria-hidden="true"
            role="presentation"
          />
          <span className="cms-block-workspace-workspace-1-workspace-form-controls__uploadSingleLoadingStatus">
            {uploadingStatusLabel}
          </span>
        </output>
      ) : item.kind === 'video' ? (
        <video
          src={item.previewUrl}
          playsInline
          muted
          preload="metadata"
          className="cms-block-workspace-workspace-1-workspace-form-controls__uploadThumbImage"
          aria-label={item.displayName}
        />
      ) : (
        <div className="cms-block-workspace-workspace-1-workspace-form-controls__unifiedReferenceAudio">
          {renderAppIcon({
            name: 'MicVocal',
            className:
              'cms-block-workspace-workspace-1-workspace-form-controls__unifiedReferenceAudioIcon',
          })}
        </div>
      )}
      {item.uploadStatus === 'failed' && item.errorMessage ? (
        <span className="cms-block-workspace-workspace-1-workspace-form-controls__uploadThumbOverlay">
          {item.errorMessage}
        </span>
      ) : item.uploadStatus === 'uploaded' && bannerLabel ? (
        <span className="cms-block-workspace-workspace-1-workspace-image-mention__thumbBanner">
          {bannerLabel}
        </span>
      ) : null}
      {item.uploadStatus !== 'uploading' ? (
        <button
          type="button"
          className="cms-block-workspace-workspace-1-workspace-form-controls__uploadThumbRemove"
          aria-label={removeLabel}
          onClick={() => onRemove?.(item.id)}
        >
          {renderAppIcon({
            name: 'X',
            className:
              'cms-block-workspace-workspace-1-workspace-form-controls__uploadThumbRemoveIcon',
          })}
        </button>
      ) : null}
    </div>
  );
}
